import axios from "axios";

const checkAuth = async (navigate, prefix) => {
    const redirectToLogin = () => {
        const loginPath = prefix ? `/${prefix}/login-user` : '/'
        localStorage.removeItem('account')
        if (navigate) {
            navigate(loginPath, { replace: true })
        }
    }

    try {
        const { data } = await axios({
            method: 'GET',
            url: `${process.env.REACT_APP_BACKEND_URL}/api/v5/sessions`,
            withCredentials: true,
        })

        if (data?.data !== "Authenticated") {
            redirectToLogin()
            return false
        }
        
        return true
    }
    catch (err) {
        if (err?.response?.status === 401) {
            redirectToLogin()
            return false
        }

        return false
    }
}

export default checkAuth